import PickUpReadyBarcode from "./PickUpReadyBarcode";
export default PickUpReadyBarcode;
